'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/defaults/transitional.js
// module id = 143
// module chunks = 0